<template>
  <b-modal
    :hide-footer="true"
    centered
    id="agenda-ativa-compromisso-modal"
    @hidden="$bvModal.hide('agenda-ativa-compromisso-modal')"
  >
    <template #modal-title>
      <strong class="font-size-19">
        {{ getAgendamentoInfo()?.title }}
      </strong>
    </template>
    <form @submit.prevent="saveAgendamento">
      <section class="row">
        <form-select
          v-if="!agendamentoCadastro.id"
          :required="true"
          label="Compromissos"
          valueOption="slug"
          grid="12"
          id="evento"
          name="evento"
          :itens="tiposCompromissos"
          :loading="loadingOptions"
          v-model="agendamentoCadastro.tipo_compromisso_id"
          @selected="setTipoCompromisso"
        />

        <form-calendar
          v-if="agendamentoCadastro.id && !agendamentoCadastro.has_data_fim"
          :required="true"
          grid="12"
          label="Nova Data"
          id="novaData"
          name="novaData"
          v-model="agendamentoCadastro.dia"
        />

        <form-select
          v-if="agendamentoCadastro.id && agendamentoCadastro.motivo_obrigatorio"
          grid="12"
          label="Motivo do reagendamento"
          id="motivo"
          name="motivo"
          v-model="agendamentoCadastro.motivo_id"
          :required="agendamentoCadastro.id && agendamentoCadastro.motivo_obrigatorio"
          :loading="loadingOptions"
          :itens="motivosReagendamento"
        />

        <div
          class="col-12 d-flex align-items-center mb-2"
          v-if="verificarRepetivel()"
        >
          <div class="float-left mr-2">
            <toggle-button
              :sync="true"
              color="#5685D8"
              id="repetivel"
              name="repetivel"
              v-model="agendamentoCadastro.repetivel"
            />
          </div>
          Deseja selecionar um período específico?
        </div>

        <form-calendar-range
          :min-date="date_now"
          :max-date="max_date"
          :required="true"
          v-if="agendamentoCadastro.repetivel"
          grid="12"
          mode="date"
          label="Período Inicial e Final"
          v-model="agendamentoCadastro.data"
        />

        <form-calendar-range
          :required="true"
          v-if="agendamentoCadastro.has_data_fim"
          grid="12"
          mode="date"
          label="Novo Período Inicial e Final"
          v-model="agendamentoCadastro.data"
        />

        <p
          class="small text-muted col-12"
          v-if="agendamentoCadastro.repetivel"
        >
          <b-icon
            icon="exclamation-triangle-fill"
            variant="warning"
            animation="fade"
          />
          OBS: Os <b>compromissos</b> cadastrados com intervalo <b>não serão criados</b> nos <b>finais de semana!</b>
        </p>

        <component
          v-if="!agendamentoCadastro.has_data_fim"
          v-for="(campo, idx) in camposDinamicos()"
          v-bind:is="campo.componente"
          :key="idx"
          v-bind="campo.props"
          :value="getCampoValue(campo.vModel)"
          @input="setCampoValue(campo.vModel, $event)"
        />

      </section>
      <section class="d-flex flex-row justify-content-end mt-3" style="column-gap: 5px">
        <button
          class="btn btn-submit-agendamento-cadastro-agenda-ativa btn-success mr-0"
          data-style="zoom-in"
          type="submit"
        >
          {{ $t(getAgendamentoInfo()?.labelButton) }}
          <i class="mdi" :class="getAgendamentoInfo()?.icon"/>
        </button>
      </section>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: "AgendaAtivaCompromissoModal",
  props: [
    "tiposCompromissos",
    "motivosReagendamento",
    "loadingOptions",
    "agendamentoCadastro",
    "saveAgendamento",
    "agendaAtivaStore"
  ],
  data() {
    return {
      date_now: moment().format("YYYY-MM-DD"),
      max_date: moment().add(30, 'days').format('YYYY-MM-DD'),
      camposPorEvento: {
        "periodo-de-ferias": [
          {
            componente: "form-calendar-range",
            props: {
              required: true,
              label: "Período Inicial e Final",
              mode: "date",
              grid: "12",
              id: "periodoInicialFim",
              name: "periodoInicialFim",
            },
            vModel: "agendamentoCadastro.data"
          },
        ],
        "afastamento": [
          {
            componente: "form-calendar-range",
            props: {
              required: true,
              label: "Período Inicial e Final",
              mode: "date",
              grid: "12",
              id: "periodoInicialFim",
              name: "periodoInicialFim",
            },
            vModel: "agendamentoCadastro.data"
          },
        ],
        "indisponibilizar-todos-os-horarios": [
          {
            componente: "form-input",
            props: {
              required: true,
              label: "Motivo",
              grid: "12",
              id: "motivo",
              name: "motivo",
            },
            vModel: "agendamentoCadastro.descricao"
          },
        ],
        defaultComponents: [
          {
            componente: "form-calendar",
            props: {
              required: true,
              label: "Horário de início",
              mode: "time",
              grid: "6",
              id: "horarioInicio",
              name: "horarioInicio",
            },
            vModel: 'agendamentoCadastro.hora_inicio'
          },
          {
            componente: "form-calendar",
            props: {
              required: true,
              label: "Horário de término",
              mode: "time",
              grid: "6",
              id: "horarioTermino",
              name: "horarioTermino",
            },
            vModel: 'agendamentoCadastro.hora_fim'
          },
        ]
      },
    }
  },
  methods: {
    setTipoCompromisso(tipoCompromissoSlug) {
      if (tipoCompromissoSlug) {
        const tipoCompromisso = this.tiposCompromissos?.find((e) => e.slug === tipoCompromissoSlug);

        this.agendaAtivaStore.commit("SET_TIPO_COMPROMISSO", tipoCompromisso);
      }
    },

    camposDinamicos() {
      const tipoCompromisso = this.tiposCompromissos.find(
        (e) => e.slug === this.agendamentoCadastro.tipo_compromisso_id
      );

      const slug = tipoCompromisso?.slug;

      switch (slug) {
        case "periodo-de-ferias":
          return this.camposPorEvento["periodo-de-ferias"];
        case "afastamento":
          return this.camposPorEvento.afastamento;
        case "indisponibilizar-todos-os-horarios":
          return this.camposPorEvento["indisponibilizar-todos-os-horarios"];
        default:
          return this.camposPorEvento.defaultComponents;
      }
    },

    getCampoValue(vModelPath) {
      return vModelPath.split(".").reduce((acc, key) => acc[key], this);
    },

    setCampoValue(vModelPath, value) {
      const keys = vModelPath.split('.');
      const lastKey = keys.pop();
      const target = keys.reduce((acc, key) => acc[key], this);
      this.$set(target, lastKey, value);
    },

    verificarRepetivel() {
      const tipo_compromisso = ["indisponibilizar-todos-os-horarios", "afastamento", "periodo-de-ferias"];
      const tipoAtual = this.agendaAtivaStore.state.tipo_compromisso?.slug;

      if (!this.agendaAtivaStore.state.tipo_compromisso) return false;

      return !tipo_compromisso.includes(tipoAtual);
    },

    getAgendamentoInfo() {
      if (this.agendamentoCadastro.id && this.agendamentoCadastro.dia_fim) {
        return {
          title: "Edição do evento/compromisso",
          labelButton: "Salvar",
          icon: "mdi-content-save"
        };
      }

      if (this.agendamentoCadastro.id) {
        return {
          title: "Reagendamento",
          labelButton: "Reagendar",
          icon: "mdi-calendar-clock"
        };
      }

      return {
        title: "Novo evento/compromisso",
        labelButton: "Salvar",
        icon: "mdi-content-save"
      };
    },
  }
}
</script>
